import InfoIcon from '@mui/icons-material/Info'
import { Divider, Grid, Stack, Typography, useTheme } from '@mui/material'
import { Fragment } from 'react'

import { i18WithParams as t } from '@shared/locales'
import { ServiceTypeIcon } from 'icon_avatar/icon_avatar'
import { ReceiptDto } from 'service-api/src/types'

const rxRemoveCount = /(\sx\s\d*\s\w*)/gm

export const OffersSection = ({ receipt }: { receipt: ReceiptDto }) => {
  const { palette } = useTheme()

  return (
    <>
      <Stack spacing={2}>
        <Divider sx={{ ml: -1, mr: -1 }} />
        {receipt.invoices?.map((invoice, invoiceIndex) => {
          const isGroom = invoice.items?.[0]?.locationServiceType?.serviceType?.name === 'grooming'
          const isEstimatedInvoiceTotal = invoice.items?.some((t) => t.priceVaries)
          return (
            <Stack key={invoiceIndex}>
              <Stack direction="row" justifyContent="space-between" mb={2}>
                <Stack direction={'row'}>
                  <ServiceTypeIcon
                    serviceType={invoice.items?.[0]?.locationServiceType?.serviceType?.name}
                    color="primary"
                    sx={{
                      fill: palette.primary.main,
                      stroke: palette.primary.main,
                      mr: 1,
                      backgroundColor: palette.primary.shade10,
                      height: '38px',
                      width: '38px',
                      borderRadius: 1,
                      p: 0.5,
                    }}
                  />
                  <Stack>
                    <Typography variant="h6">
                      {isGroom ? t('global.label.groomingRequest') : invoice.displayName}
                    </Typography>
                    {invoice.pets && <Typography variant="caption">{invoice.pets.join(', ')}</Typography>}
                  </Stack>
                </Stack>
                <Stack direction={'row'} spacing={1}>
                  {isEstimatedInvoiceTotal && (
                    <Typography variant="h6" sx={{ color: palette.action.active }}>
                      {t('global.label.estimated')}
                    </Typography>
                  )}
                  <Typography variant="h6">{invoice.subtotal}</Typography>
                </Stack>
              </Stack>
              {invoice.items?.map((item, itemIndex) => (
                <Fragment key={itemIndex}>
                  <Grid container mb={1}>
                    <Grid item xs={5}>
                      <Typography variant="body1" sx={{ flex: 'initial', marginRight: 'auto', mr: 3 }}>
                        {(item.title === 'credit' ? t('receipt.comp') : item.title?.replace(rxRemoveCount, '')) +
                          (item.pets ? ` (${item.pets.join(', ')})` : '')}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body1" component="span" sx={{ marginRight: 'auto', mr: 1 }}>
                        {item.quantity && item.price ? `${item.price} x ${item.quantity.split(' ')[0]}` : ''}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Stack direction={'row'} justifyContent={'flex-end'} spacing={1}>
                        {item.priceVaries && (
                          <InfoIcon
                            sx={{
                              width: '20px',
                              height: '20px',
                              color: palette.action.active,
                            }}
                          />
                        )}
                        <Typography variant="body1" sx={{ textAlign: 'right' }}>
                          {item.subtotal || item.price}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ textAlign: 'right', fontWeight: 'bold', marginLeft: 1 }}
                          color="text.secondary"
                        >
                          {item.taxLabel || ' '}
                        </Typography>
                      </Stack>
                    </Grid>
                  </Grid>
                </Fragment>
              ))}
            </Stack>
          )
        })}
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h6">{t('global.label.subtotal')}</Typography>
          <Typography variant="h6">{receipt.subtotal}</Typography>
        </Stack>
        <Stack spacing={1}>
          {Object.entries(receipt.taxRates || {}).map(([rate, data], index) => (
            <Stack key={index} direction="row" justifyContent="space-between">
              <Typography variant="body1">
                {t('global.label.taxPercentage', { percentage: rate, label: data.label || '' })}
              </Typography>
              <Typography variant="body1">{data.value || ''}</Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
      <Divider sx={{ mt: 1, ml: -1, mr: -1 }} />
    </>
  )
}
